module.exports = __webpack_public_path__ + "static/media/iconService4.08bc6d71.svg";